import { render, staticRenderFns } from "./NewKnowledge.vue?vue&type=template&id=00bd6752&scoped=true&"
import script from "./NewKnowledge.vue?vue&type=script&lang=js&"
export * from "./NewKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./NewKnowledge.vue?vue&type=style&index=0&id=00bd6752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd6752",
  null
  
)

export default component.exports